import React from 'react';
import { PapiDeviation, PapiOriginalsResponse } from '@wix/da-papi-types';
import TextRenderer from '@wix/da-shared-react/pkg/TextRenderer';
import QuestionDisplay from '@wix/da-ds/pkg/originals/QuestionDisplay';
import QuestionViewer from '@wix/da-editor-tiptap/pkg/components/Viewer/presets/OriginalsQuestion';

interface Props {
  deviation: PapiDeviation;
  order: PapiOriginalsResponse;
}
const QuestionnaireAnswers: React.FC<Props> = ({ deviation, order }) => {
  const { questionnaire } = deviation?.extended?.originals ?? {};
  return (
    <>
      {questionnaire?.map(question => {
        return (
          <div key={question.questionId}>
            <QuestionDisplay
              question={question}
              order={order}
              editorRenderer={body => (
                <TextRenderer
                  textContent={body}
                  tipTapViewer={QuestionViewer}
                />
              )}
            />
          </div>
        );
      })}
    </>
  );
};
QuestionnaireAnswers.displayName = 'QuestionnaireAnswers';

export default QuestionnaireAnswers;
